import React, { Dispatch, SetStateAction, useEffect, useState } from 'react';
import { BasicModalV2, TextButton } from '../../../../components';
import CustomModalHeader from '../../../Common/customComponents/CustomModalHeader.tsx';

import PermitColdWork from '/assets/icon/global/permit-cold-work-new.svg';
import PermitRoadClosure from '/assets/icon/global/permit-road-closure.svg';
import PermitSpaceWork from '/assets/icon/global/permit-space-work.svg';
import PermitHotWork from '/assets/icon/global/permit-hot-work.svg';
import { useAsync } from '../../../../hooks';

interface IProps {
  setIsModalOpen: Dispatch<SetStateAction<boolean>>;
  isModalOpen: boolean;
  permitIssueList: any;
  title: string;
  onOkAction: any;
}

const PermitIssueTypeModal = (props: IProps) => {
  const { callAsync, showAlarm, closeAlarm } = useAsync();
  const [tempPermitIssueList, setTempPermitIssueList] = useState<any>([]);

  useEffect(() => {
    if (!props.isModalOpen) {
      setTempPermitIssueList([]);
    } else {
      setTempPermitIssueList(props.permitIssueList);
    }
  }, [props.isModalOpen]);

  const modalClose = () => {
    props.setIsModalOpen(false);
  };

  const selectType = (e: any, type: string) => {
    setTempPermitIssueList((prev: any) =>
      prev.includes(type) ? prev.filter((t: any) => t !== type) : [...prev, type]
    );
  };

  const getPermitIssueIndex = (type: string) => {
    return tempPermitIssueList.includes(type) ? tempPermitIssueList.indexOf(type) + 1 : '';
  };

  const finish = () => {
    props.onOkAction(tempPermitIssueList);
    props.setIsModalOpen(false);
  };

  const onClickOk = () => {
    if (!['CW', 'HW', 'SW', 'RC'].some((type) => tempPermitIssueList.includes(type))) {
      showAlarm({
        message: 'Please select at least one Type of Work Permit.',
        modalTitle: 'Warning',
        isSingleFooter: true,
        noFooter: false,
        closeButtonProps: {
          onClick: () => {
            closeAlarm();
          }
        }
      });
    } else {
      finish();
    }
  };

  return (
    <BasicModalV2 open={props.isModalOpen} onClose={() => props.setIsModalOpen(false)}>
      <CustomModalHeader title={props.title} modalClose={modalClose} />
      <div
        className={'custom-modal-body permit-issue-type-modal'}
        style={{ width: '500px', height: '550px' }}
      >
        <div className={'sub-title'}>
          <span className={'sub-title-text'}>Type of Work Permit</span>
        </div>
        <div className={'select-type-box'}>
          <div className={'row-type-box'}>
            <div
              className={`type-item ${tempPermitIssueList.includes('CW') ? 'active' : ''}`}
              onClick={(e: any) => {
                selectType(e, 'CW');
              }}
            >
              <img src={PermitColdWork} />
              <span className={'type-item-text'}>Cold Work</span>
              <div className={'select-btn'}>{getPermitIssueIndex('CW')}</div>
            </div>
            <div
              className={`type-item ${tempPermitIssueList.includes('HW') ? 'active' : ''}`}
              onClick={(e: any) => {
                selectType(e, 'HW');
              }}
            >
              <img src={PermitHotWork} />
              <span className={'type-item-text'}>Hot Work</span>
              <div className={'select-btn'}>{getPermitIssueIndex('HW')}</div>
            </div>
          </div>
          <div className={'row-type-box'}>
            <div
              className={`type-item ${tempPermitIssueList.includes('SW') ? 'active' : ''}`}
              onClick={(e: any) => {
                selectType(e, 'SW');
              }}
            >
              <img src={PermitSpaceWork} />
              <span className={'type-item-text'}>Confined Space Work</span>
              <div className={'select-btn'}>{getPermitIssueIndex('SW')}</div>
            </div>
            <div
              className={`type-item ${tempPermitIssueList.includes('RC') ? 'active' : ''}`}
              onClick={(e: any) => {
                selectType(e, 'RC');
              }}
            >
              <img src={PermitRoadClosure} />
              <span className={'type-item-text'}>Road Closure</span>
              <div className={'select-btn'}>{getPermitIssueIndex('RC')}</div>
            </div>
          </div>
        </div>

        <div className={'custom-modal-button'}>
          <TextButton
            variant="outlined"
            onClick={() => {
              props.setIsModalOpen(false);
            }}
          >
            Cancel
          </TextButton>
          <TextButton variant="contained" onClick={onClickOk}>
            OK
          </TextButton>
        </div>
      </div>
    </BasicModalV2>
  );
};

export default PermitIssueTypeModal;
